import { useState } from 'react';
import { useOutletContext } from 'react-router-dom';
import Tab from '../../components/Tab';
import { useRecoilValue } from 'recoil';
import { pageInfoState } from '../../atoms';
import AttendanceForm from '../../components/AttendanceForm';

const CWork3 = () => {
  const size = useOutletContext<any>();
  const tabInfo = useRecoilValue(pageInfoState);
  const [currentTabMrCd, setCurrentTabMrCd] = useState(tabInfo.defaultMrCd);

  const onClickTab = (mrCd: string) => {
    setCurrentTabMrCd(mrCd);
  };

  const renderPage = () => {
    const activeTab = tabInfo.tabList?.find((el: any) => el.mrCd === currentTabMrCd);
    if (activeTab !== undefined) {
      const { mrCd } = activeTab;
      switch (mrCd) {
        case '001':
          return <AttendanceForm formType='creport' approvalType='request' />;
        case '002':
          return <AttendanceForm formType='creport' approvalType='approval' />;
      }
    }
    return undefined;
  };

  return (
    <div className='contents'>
      <Tab tabList={tabInfo.tabList} currentTabMrCd={currentTabMrCd} setCurrentTabMrCd={setCurrentTabMrCd} onClickTab={onClickTab} size={size} />
      {renderPage()}
    </div>
  );
};

export default CWork3;
